import React, { Component } from 'react';
import axios from '../../axios';
import format from 'format-number'
import { connect } from 'react-redux'
import moment from 'moment'
import { resetCekKartuState } from '../../actions/formCekKartuAction'
import Alert from 'react-s-alert'
import qs from 'qs'
import queryString from 'query-string'
import {
  Badge
} from "reactstrap";
import { SERVER_API } from '../../constants/siteConfig'
import { NavLink } from 'react-router-dom'
import Select from "react-select";


const initialState = {    
    tugas_id                : "",
    tugas_create_date       : moment().format('YYYY-MM-DD'),
    tugas_due_date          : moment().format('YYYY-MM-DD'),
    tugas_judul             : "",
    tugas_desc              : "",
    kelas_nama              : "",
    mapel_nama              : "",
    user_nama              : "",
    tugas_progress          : "",
    dataKelas       : [],
    student_upload_count    : 0,
    dataTugas               : [],  
    files               : [],
    dataTugasAnswer     : [],
    isButtonLoading     : false,
    isLoading           : false,
}

class TugasDetail extends Component {
    constructor(props) {
        super(props)

        this.state = initialState
    }

    loadDataKelas() {
        this.setState({isLoadingDataKelas: true});

        const params = qs.stringify({
            locale: "id",
            platform: "web"
        })

        axios({
            method: 'post',
            url: '/exam/category-mapel-kelas?' + params
        })

            .then(response => {
                const result = response.data;
                if (result.status) {
                    const dataKelas = result.data.kelas.map(item => ({
                        value: item.kelas_id,
                        label: item.kelas_nama
                    }));

                    this.setState({
                        dataKelas,
                        isLoadingDataKelas: false
                    });
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }

                    this.setState({isLoadingDataKelas: false});
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({isLoadingDataKelas: false});
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDetailData() {

       this.setState({ isLoading: true })

        const params = qs.stringify({
            locale:"id",
            platform:"web",
            tugas_id:this.props.match.params.tugas_id
        })
        
        axios({
            method: 'post',
            url: '/tugas/detail?' + params
        })
        .then((response) => {

            const result = response.data
            
            if (result.status === true) {                
                
                this.setState({
                    dataTugas: result.data.tugas[0],
                    kelas_id        : result.data.tugas[0].kelas_id.split(","),
                    files:result.data.tugas[0].tugas_file,
                    isLoading: false 
                })

                var data_kelas_id = []

                for (var i=0; i<this.state.kelas_id.length; i++) {
                    var arr_kelas_id =[]
                    arr_kelas_id["kelas_id"]= this.state.kelas_id[i]
                    data_kelas_id[i] = arr_kelas_id
                }

                const participants = data_kelas_id.map(
                    item => item.kelas_id
                );

                const kelasNew = data_kelas_id.map(item => ({
                    "kelas_id": item.kelas_id
                }));
                //
                // newState.participants = participants.join(",");
                // newState.kelasNew = kelasNew

                this.setState(
                    {
                        kelasNew: kelasNew,
                        participants: participants.join(",")
                    }
                );

            }
            else {
           
                Alert.error(result.text)
                this.setState({ isLoading: false, dataTugas:[] })
            }      
        })
        .catch((error) => {
            console.log(error)
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
    }

    loadDetailAnswer() {

       this.setState({ isLoading: true })

        const params = qs.stringify({
            locale:"id",
            platform:"web",
            tugas_id:this.props.match.params.tugas_id
        })
        
        axios({
            method: 'post',
            url: '/tugas/hasil-list?' + params
        })

        .then((response) => {

            const result = response.data
            console.log(result)
            if (result.status === true) {                
                
                this.setState({
                    dataTugasAnswer: result.data.tugas_answer,
                    isLoading: false 
                })
            }
            else {
           
                Alert.error(result.text)
                this.setState({ isLoading: false, dataTugasAnswer:[] })
            }      
        })
        .catch((error) => {
            console.log(error)
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
    }
    
    componentDidMount() {
        this.loadDetailData()
        this.loadDataKelas()
        this.loadDetailAnswer()
    }
    
    render() {
        if (this.state.dataTugas.tugas_progress == 'finish') {
            var iconThumb = "warning";
        } else {
            var iconThumb = "danger";
        }
        return (
            <div className="col-sm-12">                
                <div className="card">
                    <div className="card-header">
                        Informasi Tugas
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Tugas Judul</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataTugas.tugas_judul}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Tugas Create Date</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataTugas.tugas_create_date}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Batas Pengumpulan</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataTugas.tugas_due_date}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">
                                Kelas yang mengikuti
                            </label>
                            <div className="col-md-10">

                                <Select
                                    disabled="disabled"
                                    multi
                                    value={this.state.participants}
                                    onChange={text =>
                                        this.handleChangeMultiSelect("participants", text)
                                    }
                                    options={this.state.dataKelas}
                                    placeholder="Kelas yang mengikuti"
                                    removeSelected={this.state.removeSelected}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Mapel</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataTugas.mapel_nama}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Guru</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataTugas.user_nama}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Progres</label>
                            <div className="col-md-10">
                                {": "}<b><Badge color={iconThumb}>{this.state.dataTugas.tugas_progress_text}</Badge></b>
                            </div>
                        </div>                                             
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        Files
                    </div>
                    <div className="card-block">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="25">No</th>
                                    <th>Nama Item</th>
                                    <th>Format</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>                                                                
                            {
                                this.state.files.map((item, i) => (
                                    item.tugas_type === 'file' ? (
                                        <tr key={"files" + i}>
                                            <td>
                                                {i + 1}
                                            </td>
                                            <td>
                                                {item.tugas_file_nama}
                                            </td>
                                            <td>
                                                {item.tugas_file_ext}
                                            </td>
                                            <td>
                                                <a href={item.tugas_file_url} target="_blank" rel="noopener noreferrer">Download</a>
                                            </td>
                                        </tr>
                                    ):(
                                        <tr key={"files" + i}>
                                            <td>
                                                {i + 1}
                                            </td>
                                            <td colSpan={3}>
                                                <iframe width="360" height="215"
                                                        src={"https://www.youtube.com/embed/"+ item.tugas_file_nama} frameBorder="0"
                                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                                        allowFullScreen>

                                                </iframe>
                                            </td>
                                        </tr>
                                    )
                                ))
                            }       
                            </tbody>
                        </table>   
                    </div>
                </div>  
                <div className="card">
                    <div className="card-header">
                        Siswa List
                    </div>
                    <div className="card-block">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="25">No</th>
                                    <th>Nama Siswa</th>
                                    <th width={50}>Nilai</th>
                                    <th width={200}>Dijawab</th>
                                    <th width={100}>Status</th>
                                    <th width={100}>Detail</th>
                                </tr>
                            </thead>
                            <tbody>                                                                
                            {
                                this.state.dataTugasAnswer.map((item, i) => (
                                    <tr key={"dataTugasAnswer" + i}>
                                        <td>
                                            {i + 1}
                                        </td>
                                        <td>
                                            {item.user_nama}
                                        </td>
                                        <td>
                                            {item.ta_nilai ? item.ta_nilai : '0'}
                                        </td>
                                        <td>
                                            {item.ta_create_date}
                                        </td>
                                        <td>
                                            <Badge color={iconThumb}>{item.ta_status}</Badge>
                                        </td>
                                        <td>                                            
                                            <a href={`${'#/tugas/answer/detail/'+item.tugas_answer_id}`} target="_blank" rel="noopener noreferrer" className="btn btn-primary"><i className="fa fa-eye"></i> Detail</a>
                                        </td>
                                        
                                    </tr>
                                ))
                            }       
                            </tbody>
                        </table>   
                    </div>
                </div> 
            </div>
        );
    }
}

export default TugasDetail;


// WEBPACK FOOTER //
// ./src/views/Tugas/TugasDetail.js